'use client'

import { ElectronicsWhySectionModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import WhySectionCard from './WhySectionCard'

type Props = { content: ElectronicsWhySectionModel }

const WhySection = ({ content: { title, cards } }: Props) => {
  return (
    <section data-testid="why-section" className="electronics__why-section">
      <h2 className="electronics__why-title">{title}</h2>
      <div className="electronics__why-cards-container">
        {cards.map((card, index) => (
          <WhySectionCard {...card} key={index} />
        ))}
      </div>
    </section>
  )
}

export default WhySection
